(function () {
  'use strict';

  angular.module('ringbaPortal').component('campaignPayoutsSummary', {
    bindings: {
      priorityToShow: '<',
      isOverridden: '<',
      campaignPayouts: '<',
      showSettings: '&'
    },
    controller: CampaignPayoutsSummaryController,
    controllerAs: 'vm',
    templateUrl: '/scripts/shared/components/add-affiliate/campaign-payouts-summary/campaign-payouts-summary.view.html'
  });

  function CampaignPayoutsSummaryController(
    $filter
  ) {
    'ngInject';

    const vm = this;

    vm.$onChanges = onChanges;

    function onChanges() {
      vm.payoutSummaryText = _getSummaryText(vm.isOverridden, vm.campaignPayouts);
    }

    function _getSummaryText(isOverridden, campaignPayouts) {
      let translation = 'ADD_AFFILIATE_CAMPAIGN_PAYOUTS_SUMMARY_NO_PAYOUTS';
      if(isOverridden && (!campaignPayouts || !campaignPayouts.length)) {
        translation = 'ADD_AFFILIATE_CAMPAIGN_PAYOUTS_SUMMARY_WITHOUT_PAYOUTS';
      } else if (campaignPayouts && campaignPayouts.length) {
        translation = 'ADD_AFFILIATE_CAMPAIGN_PAYOUTS_SUMMARY_WITH_PAYOUTS';
      }
      return $filter('translate')(translation);
    }

  }
})();
